import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addInventoryLog, getInventoryLogs, deleteInventoryLog } from '../../services/inventoryService';

export const fetchInventoryLogs = createAsyncThunk(
    'inventory/fetchLogs',
    async (filters, { rejectWithValue }) => {
        try {
            return await getInventoryLogs(filters);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const createInventoryRecord = createAsyncThunk(
    'inventory/createRecord',
    async (logData, { rejectWithValue }) => {
        try {
            const logId = await addInventoryLog(logData);
            return { id: logId, ...logData, createdAt: new Date().toISOString() };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const removeInventoryRecord = createAsyncThunk(
    'inventory/removeRecord',
    async (logId, { rejectWithValue }) => {
        try {
            await deleteInventoryLog(logId);
            return logId;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const inventorySlice = createSlice({
    name: 'inventory',
    initialState: {
        logs: [],
        loading: false,
        error: null,
        success: false
    },
    reducers: {
        clearInventoryMessages: (state) => {
            state.error = null;
            state.success = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInventoryLogs.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchInventoryLogs.fulfilled, (state, action) => {
                state.loading = false;
                state.logs = action.payload;
            })
            .addCase(fetchInventoryLogs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(createInventoryRecord.pending, (state) => {
                state.loading = true;
                state.success = false;
            })
            .addCase(createInventoryRecord.fulfilled, (state, action) => {
                state.loading = false;
                state.logs.unshift(action.payload);
                state.success = true;
            })
            .addCase(createInventoryRecord.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(removeInventoryRecord.fulfilled, (state, action) => {
                state.logs = state.logs.filter(log => log.id !== action.payload);
            });
    }
});

export const { clearInventoryMessages } = inventorySlice.actions;
export default inventorySlice.reducer;
